import React, { useRef } from 'react';
import { useIntl } from 'umi';
import { Modal, Button } from 'tea-component';
import {
  UseFormSearch,
  type ISearchRef,
} from '@gp/pages/Pipeline/ProjectDetails/components/GameOverviewEdit/Components/UseFormSearch';
import { useHtmlPublishForm } from './useHtmlPublishForm';
import './index.scss';

/** HTML 发布到经分弹窗入参 */
export type IHtmlPublishModalProps = {
  /** HTML 报告相对路径（/as/report/...） */
  htmlPath: string;
  /** 关闭弹窗 */
  onClose: () => void;
};

/**
 * Gallery Report 发布弹窗：表单用 UseFormSearch，按钮对齐经分新增报表
 */
const HtmlPublishModal: React.FC<IHtmlPublishModalProps> = ({
  htmlPath,
  onClose,
}) => {
  const { formatMessage } = useIntl();
  const searchFormRef = useRef<ISearchRef>(null);
  const { config, initialValues, handleFormSubmit, submitDisabled } =
    useHtmlPublishForm({
      htmlPath,
      onSuccess: onClose,
      formRef: searchFormRef,
    });

  return (
    <Modal
      visible
      disableEscape
      size={680}
      caption={formatMessage({ id: 'dbh_studio_aigallery_report_publish' })}
      onClose={onClose}
    >
      <Modal.Body>
        {UseFormSearch({
          config,
          getFormValue: handleFormSubmit,
          labelSpan: 6,
          column: 1,
          isUnpack: false,
          initialValues,
          ref: searchFormRef,
          isShowSearchBtn: false,
        })}
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          disabled={submitDisabled}
          onClick={() => searchFormRef.current?.handleSubmit?.()}
        >
          {formatMessage({ id: 'dbh_studio_aigallery_report_publish' })}
        </Button>
        <Button type="weak" onClick={onClose}>
          {formatMessage({ id: 'menu_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HtmlPublishModal;
